
import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import AuthForm from "@/components/auth/AuthForm";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useMetadata } from "@/hooks/useMetadata";
import { APP_METADATA } from "@/constants/metadata";
import ClustrLogo from "@/components/icons/ClustrLogo";

const Auth = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { title, description, image } = APP_METADATA.auth;
  useMetadata({ title, description, image });

  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-16 bg-gradient-to-br from-white to-clustr-lightGray">
      <div className="mb-8 text-center">
        <Link to="/" className="block">
          <ClustrLogo 
            className="h-24 mx-auto mb-4"
            width={196}
            height={96}
          />
        </Link>
        <p className="text-lg text-clustr-darkGray">
          Your personal inspiration library
        </p>
      </div>
      
      <AuthForm />
      
      <Alert className="max-w-md mt-6 mb-4 bg-amber-50 border-amber-200">
        <AlertTriangle className="h-4 w-4 text-amber-500" />
        <AlertTitle className="text-amber-700">Troubleshooting</AlertTitle>
        <AlertDescription className="text-amber-600">
          If you're not receiving confirmation emails, try:
          <ul className="list-disc pl-5 mt-2 space-y-1">
            <li>Checking your spam/junk folder</li>
            <li>Using a different email provider</li>
            <li>Trying the "Try Sign In Again" option</li>
          </ul>
        </AlertDescription>
      </Alert>
      
      <div className="mt-0 text-center text-sm text-clustr-darkGray max-w-md">
        <p className="mb-2">
          Organize inspiration and research from around the internet.
        </p>
        <p className="text-xs text-clustr-mediumGray">
          © {new Date().getFullYear()} Clustr. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Auth;
